<div *ngIf="step <= 3" class="preview-container" [style.background-image]="getBackgroundImage()"></div>

<div class="preview-container" id="previewContainer" *ngIf="step > 3">
  <div class="preview-loader" *ngIf="isPreviewLoading">
    <ng-casto-loader></ng-casto-loader>
  </div>
  <div class="closet-doors-custom-layers" id="layers" *ngIf="!isPreviewLoading">
    <!-- Vantaux -->
    <div
      class="sublayers door"
      *ngFor="let door of preview"
      [id]="'element' + door.position"
      [ngStyle]="{
        height: doorHeight + 'px',
        width: calculateDoorWidth() + 'px',
        'margin-left': door.product.isOffset ? '-' + calculateOffset(door.product.offsetValue) + 'px' : null,
      }"
      [class]="'rail' + door.product.orderFromFront + ' ' + getOpeningSystemStr()"
      [ngClass]="{ active: door.position === selectedDoor && finishesStep === 1 && step === 4 }">
      <!-- Sous-éléments du vantail -->
      <ng-container *ngFor="let item of door.product.items">
        <!-- Profilés supérieur et inférieur -->
        <div
          *ngIf="item.product.type.includes('profile')"
          [class]="item.product.type"
          [ngStyle]="{ height: calculateElementMmToPx(item.product.height) + 'px', width: '100%' }">
          <div
            class="subprofile"
            [ngStyle]="{
              'background-image': 'url(' + baseImgURL + item.product.path + ')',
              'background-size': calculateElementMmToPx(configuration.clientWidth) + 'px 100%',
              'background-position-x': calculateElementMmToPx(configuration.clientWidth / door.position) + 'px',
            }"></div>
        </div>

        <!-- Centre du vantail -->
        <div *ngIf="item.product.type.includes('body')" [class]="item.product.type">
          <ng-container *ngFor="let bodyItem of item.product.items">
            <!-- Profilés latéraux -->
            <div
              *ngIf="bodyItem.product.type.includes('profile')"
              [class]="bodyItem.product.type"
              [ngStyle]="{ width: calculateElementMmToPx(bodyItem.product.width) + 'px' }">
              <div
                class="subprofile"
                [ngStyle]="{ 'background-image': 'url(' + baseImgURL + bodyItem.product.path + ')' }"></div>
            </div>

            <!-- Partie centrale -->
            <div *ngIf="bodyItem.product.type.includes('decor')" [class]="bodyItem.product.type">
              <ng-container *ngFor="let decorItem of bodyItem.product.items">
                <!-- Barre verticale -->
                <div
                  *ngIf="decorItem.product.type.includes('crosstie-vertical')"
                  [class]="decorItem.product.type"
                  [ngStyle]="{
                    'background-image': 'url(' + baseImgURL + decorItem.product.path + ')',
                    width: calculateElementMmToPx(decorItem.product.width) + 'px',
                    height: calculateElementMmToPx(decorItem.product.height) + 'px',
                    top: calculateElementMmToPx(decorItem.product.top) + 'px',
                    left: calculateElementMmToPx(decorItem.product.left) + 'px',
                  }"></div>

                <!-- Barre horizontale -->
                <div
                  *ngIf="decorItem.product.type.includes('crosstie-horizontal')"
                  [class]="decorItem.product.type"
                  [ngStyle]="{
                    'background-image': 'url(' + baseImgURL + decorItem.product.path + ')',
                    width: '100%',
                    height: calculateElementMmToPx(decorItem.product.height) + 'px',
                    top: calculateElementMmToPx(decorItem.product.top) + 'px',
                    left: calculateElementMmToPx(decorItem.product.left) + 'px',
                  }"></div>

                <!-- Motifs gamme graphics de Kazed -->
                <div
                  *ngIf="decorItem.product.type.includes('motif-graphics')"
                  [class]="decorItem.product.type"
                  [ngStyle]="{
                    'background-image': 'url(' + baseImgURL + decorItem.product.path + ')',
                    width: calculateElementMmToPx(decorItem.product.width) + 'px',
                    height: calculateElementMmToPx(decorItem.product.height) + 'px',
                    top: calculateElementMmToPx(decorItem.product.top) + 'px',
                    left: calculateElementMmToPx(decorItem.product.left) + 'px',
                  }"></div>

                <!-- Décors -->
                <div
                  *ngIf="decorItem.product.type.includes('door-section')"
                  [ngClass]="[
                    decorItem.product.type,
                    isSectionSelected(decorItem.product.area, door.position) && finishesStep === 2 && step === 4
                      ? 'selected'
                      : '',
                  ]"
                  [id]="'decoration' + decorItem.product.area"
                  (click)="selectDecoration(door.position, decorItem.product.area)"
                  [ngStyle]="{
                    'background-image': 'url(' + getDecorImg(decorItem.product, door.position) + ')',
                    width: calculateElementMmToPx(decorItem.product.width) + 'px',
                    height: calculateElementMmToPx(decorItem.product.height) + 'px',
                    top: calculateElementMmToPx(decorItem.product.top) + 'px',
                    left: calculateElementMmToPx(decorItem.product.left) + 'px',
                  }">
                  <div
                    class="decoration-button"
                    [ngClass]="{
                      active:
                        isSectionSelected(decorItem.product.area, door.position) && finishesStep === 2 && step === 4,
                    }"
                    id="decorationButton"
                    *ngIf="finishesStep === 2 && step === 4">
                    <svg>
                      <use xlink:href="assets/img/icons.svg#icon-action-edit"></use>
                    </svg>
                  </div>
                </div>

                <!-- Profilé inferieur -->
                <div
                  *ngIf="decorItem.product.type.includes('bottom-profile')"
                  [class]="decorItem.product.type"
                  [ngStyle]="{
                    'background-image': 'url(' + baseImgURL + decorItem.product.path + ')',
                    width: '100%',
                    height: calculateElementMmToPx(decorItem.product.height) + 'px',
                    bottom: 0,
                    left: 0,
                  }"></div>
              </ng-container>

              <div
                *ngIf="hasHandle()"
                [class]="'handle ' + handleSide(door.position)"
                [ngStyle]="{
                  'background-image': 'url(' + handle.path + ')',
                  width: calculateElementMmToPx(handle.width) + 'px',
                  height: calculateElementMmToPx(handle.height) + 'px',
                }"></div>
            </div>
          </ng-container>
        </div>

        <!-- Roulettes -->
        <div
          *ngIf="item.product.type.includes('wheels')"
          [class]="item.product.type"
          [ngStyle]="{
            height: item.product.height + '%',
            width: item.product.width + '100%',
            'margin-bottom': item.product.marginBottom + '%',
          }">
          <ng-container *ngFor="let wheelItem of item.product.items">
            <div
              [class]="wheelItem.product.type"
              [ngStyle]="{
                'background-image': 'url(' + baseImgURL + wheelItem.product.path + ')',
                width: wheelItem.product.width + '%',
                height: wheelItem.product.height + '%',
              }"></div>
          </ng-container>
        </div>

        <!-- Rail inférieur -->
        <div
          *ngIf="item.product.type.includes('wheel-bar')"
          [class]="item.product.type"
          [ngStyle]="{
            'background-image': 'url(' + baseImgURL + item.product.path + ')',
            height: calculateElementMmToPx(item.product.height) + 'px',
            width: '100%',
          }"></div>
      </ng-container>
    </div>

    <div
      class="placard"
      [ngStyle]="{ height: doorHeight + 'px', width: calculateElementMmToPx(configuration.clientWidth) + 'px' }"></div>
  </div>
</div>
<div class="preview-floor" *ngIf="step > 3"></div>
